var tabsItem = 'item_tabsItem__qq1dk54';
var tabsItemHorizontalGap = 'var(--tabs-item-horizontal-gap__qq1dk51)';

export { tabsItem, tabsItemHorizontalGap };
//# sourceMappingURL=item.vanilla.mjs.map
